import { Route, Switch, Redirect, useLocation } from 'wouter';
import { useAuth } from '@/lib/auth/AuthProvider';
import LoginPage from '@/pages/Login';
import AcceptInvitePage from '@/pages/AcceptInvite';
import DashboardPage from '@/pages/Dashboard';
import EmployeesPage from '@/pages/Employees';
import EndClientsPage from '@/pages/EndClients';
import LicensesPage from '@/pages/Licenses';
import InterviewsPage from '@/pages/Interviews';
import TestsPage from '@/pages/Tests';
import BillingPage from '@/pages/Billing';
import GuidesPage from '@/pages/Guides';
import CandidateGuidePage from '@/pages/CandidateGuide';
import { AppShell } from '@/components/layout/AppShell';
import { BootSplash } from '@/components/layout/BootSplash';

export default function App() {
  const { loading, session, employee } = useAuth();
  const [location] = useLocation();

  // The candidate guide is a public, unauthenticated page. Render it before
  // any auth gating so shareable links work without a login.
  if (location === '/candidate-guide') return <CandidateGuidePage />;

  if (loading) return <BootSplash />;

  if (!session || !employee) {
    return (
      <Switch>
        <Route path="/auth/invite" component={AcceptInvitePage} />
        <Route path="/login" component={LoginPage} />
        <Route>
          <Redirect to="/login" />
        </Route>
      </Switch>
    );
  }

  return (
    <AppShell>
      <Switch>
        <Route path="/" component={DashboardPage} />
        <Route path="/employees" component={EmployeesPage} />
        <Route path="/end-clients" component={EndClientsPage} />
        <Route path="/licenses" component={LicensesPage} />
        <Route path="/interviews" component={InterviewsPage} />
        <Route path="/tests" component={TestsPage} />
        <Route path="/billing" component={BillingPage} />
        <Route path="/guides" component={GuidesPage} />
        <Route>
          <Redirect to="/" />
        </Route>
      </Switch>
    </AppShell>
  );
}
